import { Grid } from "@mui/material";
import Footer from "./Footer";
// ✅ Después
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Barra from "./Barra/Barra";
import { PrivateRoute } from "../firebase/PrivateRoute";
import { useEffect } from "react";

import Pagina_404 from "./Secciones/Pagina_404";
import Seccion_Home from "./Secciones/Seccion_Home";
import Seccion_Servicios from "./Secciones/Seccion_Servicios";
import Seccion_Sobre_Mi from "./Secciones/Seccion_Sobre_Mi";
import Seccion_Consulta from "./Secciones/Seccion_Consulta";
import Seccion_Lista_Proyectos from "./Secciones/Seccion_Lista_Proyectos";
import Seccion_Proyectos from "./Secciones/Seccion_Proyectos";
import Seccion_Lista_Blogs from "./Secciones/Seccion_Lista_Blogs";
import Seccion_Martha from "./Secciones/Seccion_Martha";
import Seccion_Blog_Dinamico from "./Secciones/Seccion_Blog_Dinamico";
import Seccion_Login from "./Secciones/Seccion_Login";
import Seccion_Servicio_Router from "./Secciones/Seccion_Servicio_Router";
import Seccion_Solucion_Dinamico from "./Secciones/Seccion_Solucion_Dinamico";
import TerminosCondiciones from "./Secciones/TerminosCondiciones";
import PoliticaPrivacidad from "./Secciones/PoliticaPrivacidad";
import PoliticaCookies from "./Secciones/PoliticaCookies";
import LayoutDashboard from "./Secciones/Componentes/LayoutDashboards";
import Crear_Proyecto from "./Secciones/Componentes/Crear_Proyecto";
import Crear_Proyecto_Dashboard from "./Secciones/Componentes/Crear_Proyecto_Dashboard";
import Editar_Proyecto_Dashboard from "./Secciones/Componentes/Editar_Proyecto_Dashboard";
import Lista_Prueba from "./Secciones/Componentes/Lista_Prueba";
import Crear_Blog_Dashboard from "./Secciones/Componentes/Crear_Blog_Dashboard";
import Editar_Blogs_Dashboard from "./Secciones/Componentes/Editar_Blogs_Dashboard";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const ContenidoPagina = () => {
    return (
        <>
            <ScrollToTop />

            <Grid container sx={{ zIndex: 4 }}>
                <Barra />
            </Grid>

            <main role="main" style={{ display: 'contents' }}>
                <Routes>
                    <Route path="/" element={<Seccion_Home />} />
                    <Route path="/servicios/" element={<Seccion_Servicios />} />
                    <Route path="/nosotros/" element={<Seccion_Sobre_Mi />} />
                    <Route path="/contacto/" element={<Seccion_Consulta />} />
                    <Route path="/proyectos/" element={<Seccion_Lista_Proyectos />} />
                    <Route path="/proyectos/:id/" element={<Seccion_Proyectos />} />
                    <Route path="/blogs/" element={<Seccion_Lista_Blogs />} />
                    <Route path="/martha/" element={<Seccion_Martha />} />
                    <Route path="/blog/:id/" element={<Seccion_Blog_Dinamico />} />
                    <Route path="/login" element={<Seccion_Login />} />
                    <Route path="/servicios/:categoria/" element={<Seccion_Servicio_Router />} />
                    <Route path="/servicios/:categoria/:servicio/" element={<Seccion_Servicio_Router />} />
                    <Route path="/soluciones/:id/" element={<Seccion_Solucion_Dinamico />} />

                    <Route path="/terminos-y-condiciones/" element={<TerminosCondiciones />} />
                    <Route path="/politica-de-privacidad/" element={<PoliticaPrivacidad />} />
                    <Route path="/politica-de-cookies/" element={<PoliticaCookies />} />

                    <Route path="/dashboard/" element={
                        <PrivateRoute allowedRoles={["admin"]}>
                            <LayoutDashboard />
                        </PrivateRoute>
                    }>
                        <Route index element={<Navigate to="proyectos" replace />} />
                        <Route path="proyectos" element={<Crear_Proyecto />} />
                        <Route path="proyectos/crear" element={<Crear_Proyecto_Dashboard />} />
                        <Route path="proyectos/:id" element={<Editar_Proyecto_Dashboard />} />
                        <Route path="blogs/" element={<Lista_Prueba />} />
                        <Route path="blogs/crear" element={<Crear_Blog_Dashboard />} />
                        <Route path="blogs/:id" element={<Editar_Blogs_Dashboard />} />
                    </Route>

                    <Route path="*" element={<Pagina_404 />} />
                </Routes>
            </main>

            <Grid container>
                <Footer />
            </Grid>
        </>
    );
};

const Pagina = () => {
    return (
        <Router>
            <Grid container justifyContent={'center'} alignItems={'center'}>
                <ContenidoPagina />
            </Grid>
        </Router>
    );
};

export default Pagina;